import styled from 'styled-components';
import { Banner } from '@trevor/ui-components';

export const CachedInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-m);
  margin-bottom: var(--spacing-xxs);
`;

export const CachedInfoBanner = styled(Banner).attrs({ severity: 'warning' })`
  align-items: center;
  padding-top: var(--spacing-s);
  padding-bottom: var(--spacing-s);

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-l);
  }
`;
